import { render } from "./ClickAndLearnSettingsPage.vue?vue&type=template&id=5f1829fd&scoped=true"
import script from "./ClickAndLearnSettingsPage.vue?vue&type=script&lang=js"
export * from "./ClickAndLearnSettingsPage.vue?vue&type=script&lang=js"

import "./ClickAndLearnSettingsPage.vue?vue&type=style&index=0&id=5f1829fd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1829fd"],['__file',"src/views/ClickAndLearnSettingsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f1829fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f1829fd', __exports__)) {
    api.reload('5f1829fd', __exports__)
  }
  
  module.hot.accept("./ClickAndLearnSettingsPage.vue?vue&type=template&id=5f1829fd&scoped=true", () => {
    api.rerender('5f1829fd', render)
  })

}


export default __exports__